import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CookieLawService } from './cookie-law.service';
import { Cookie, CookieExpiration, CookieFiltered, CookieProvider, CookieType } from './cookie-law.entity';

@Component({
  selector: 'sacyr-cookie-law',
  templateUrl: './cookie-law.component.html',
  styleUrls: ['./cookie-law.component.scss']
})
export class CokieLawComponent implements OnInit {

  @Output() outStoreGoogleCookies: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _IS_ACCUAMA_CLASSIC = true;
  private _COOKIE_SHOULD_SHOW = 'moove_gdpr_popup';

  private _cookies: Cookie[] = [];
  private _cookiesTypes: CookieType[] = [
    CookieType.ANALYTICS,
    CookieType.TECNOLOGICAL
  ];

  _cookiesFiltered: CookieFiltered[] = [];

  PROVIDER_SELF = CookieProvider.SELF;
  COOKIES_ACCEPTED = false;
  COOKIES_SHOW_DETAIL = false;
  TYPE_SELECTED = this._cookiesTypes[0];

  constructor(private cookieService: CookieLawService) { }

  ngOnInit(): void {
    this.COOKIES_ACCEPTED = this.hasAcceptedCookies();
    this.fillCookiesList();
    this.getCookies();
  }

  private fillCookiesList() {
    this._cookies = [];

    this._cookies.push(new Cookie(
      this._COOKIE_SHOULD_SHOW,
      CookieProvider.SELF,
      CookieExpiration.YEAR,
      'Usamos esta cookie para mantener la preferencia de cookies establecida por el usuario',
      CookieType.TECNOLOGICAL
    ));

    this._cookies.push(new Cookie(
      'PHPSESSID',
      CookieProvider.SELF,
      CookieExpiration.SESSION,
      'Cookie de sesión usada por PHP.',
      CookieType.TECNOLOGICAL
    ));

    if (this._IS_ACCUAMA_CLASSIC) {
      this._cookies.push(new Cookie(
        'tramitesonline',
        CookieProvider.SELF,
        CookieExpiration.SESSION,
        '',
        CookieType.TECNOLOGICAL
      ));
    }

    this._cookies.push(new Cookie('_gat', CookieProvider.GOOGLE, CookieExpiration.SESSION, '', CookieType.ANALYTICS));
    this._cookies.push(new Cookie('_gid', CookieProvider.GOOGLE, CookieExpiration.SESSION, '', CookieType.ANALYTICS));
    this._cookies.push(new Cookie('_ga', CookieProvider.GOOGLE, CookieExpiration.SESSION, '', CookieType.ANALYTICS));

    this.fillCookiesListByType();
  }

  private fillCookiesListByType() {
    var self = this;
    this._cookiesTypes.forEach(function(type) {
      self._cookiesFiltered.push({
        type: type,
        cookies: self.filterCookiesList(type)
      });
    });
  }

  private hasAcceptedCookies() {
    var value = this.cookieService.get(this._COOKIE_SHOULD_SHOW);
    return value !== null && value.trim() !== '';
  }

  private getCookies() {
    const cookieMain = this.cookieService.get(this._COOKIE_SHOULD_SHOW);
    if (!cookieMain) return;

    var json = [];

    try {
      json = JSON.parse(cookieMain);
    } catch (e) {
      console.error('JSON inválido en cookie:', e);
      return;
    }

    var storeGoogleCookies = false;

    this._cookiesFiltered.forEach(cf => {
      cf.cookies.forEach(cookie => {

        var saved = json.find(function (jc) { return jc.name === cookie.name; });

        if (saved && saved.hasOwnProperty('checked')) {
          cookie.checked = saved.checked;
        } else {
          cookie.checked = false;
        }

        if (cookie.provider === CookieProvider.GOOGLE) {
          storeGoogleCookies = cookie.checked;
        }
      });
    });

    this.outStoreGoogleCookies.emit(storeGoogleCookies);

    setTimeout(() => {
      this.setCookies();
    }, 10000);
  }

  private setCookies() {
    try {
      this._cookiesFiltered.forEach(cf => {
        cf.cookies.forEach(cookie => {

          if (cookie.name === this._COOKIE_SHOULD_SHOW) {
            cookie.value = this.getCookiesAsJSON();
          }

          this.cookieService.set(
            cookie.name,
            cookie.value || '',
            cookie.checked || false,
            cookie.options || {}
          );
        });
      });

      this.COOKIES_ACCEPTED = true;

    } catch (error) {
      console.error('Error guardando cookies:', error);
    }
  }

  private getCookiesAsJSON() {
    var json = [];

    this._cookiesFiltered.forEach(cf => {
      cf.cookies.forEach(cookie => {
        json.push({
          name: cookie.name,
          checked: !!cookie.checked
        });
      });
    });

    return JSON.stringify(json);
  }

  filterCookiesList(type?: CookieType, provider?: CookieProvider): Cookie[] {
    return this._cookies.filter(cookie => {
      var matchType = type ? cookie.type === type : true;
      var matchProvider = provider ? cookie.provider === provider : true;
      return matchType && matchProvider;
    });
  }

  hasCookiesChecked(type: CookieType) {
    return this.filterCookiesList(type).some(function (cookie) {
      return !!cookie.checked;
    });
  }

  onCheckChecked(type: CookieType) {
    const cf = this._cookiesFiltered.find(cf => cf.type === type);
    if (!cf || !cf.cookies) return;

    cf.cookies.forEach(cookie => {
      cookie.checked = !cookie.checked;
    });
  }

  onCookiesAccepted() {
    this.setCookies();
  }

  onTypeSelected(type: CookieType) {
    this.TYPE_SELECTED = type;
  }
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/cookie-law/cookie-law.component.ts